import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownPipe } from '../../../../shared/pipes/markdown.pipe';

@Component({
  selector: 'app-confirmation-card',
  standalone: true,
  imports: [CommonModule, MarkdownPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="confirmation-card">
      <div class="confirmation-card__header">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
        <span>{{ headerLabel }}</span>
      </div>
      @if (content) {
        <div class="confirmation-card__body" [innerHTML]="content | markdown"></div>
      }
    </div>
  `,
  styles: [`
    .confirmation-card {
      border: 1px solid #bbf7d0;
      border-radius: 10px;
      overflow: hidden;
      margin-top: 8px;
      background: #f0fdf4;

      &__header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        font-size: 0.84rem;
        font-weight: 600;
        color: #15803d;
        i { font-size: 1rem; }
      }

      &__body {
        padding: 0 14px 12px;
        font-size: 0.82rem;
        color: #166534;
      }
    }
  `],
})
export class ConfirmationCardComponent {
  /** Markdown body content. */
  @Input() content?: string;
  @Input() headerLabel = 'Meeting Recorded';
}
